import {
  Breadcrumbs,
  Breadcrumb,
  BreadcrumbSeparator,
} from "@tokenterminal/core/ui/navigation/breadcrumbs/Breadcrumbs"
import { ClientOnlySuspense } from "components/ClientOnlySuspense"
import { DataGridExportButton } from "modules/datatable/DataGridExportButton"
import { PresetSelector } from "modules/datatable/PresetSelector"
import {
  FeatureSwitch,
  useFeatureSwitch,
} from "modules/featureswitch/FeatureSwitch"
import { Suspense, forwardRef } from "react"
import { type Mart } from "types/ApiTypes"
import {
  DatasetSelector,
  DatasetSelectorSkeleton,
} from "../datatable/DatasetSelector"
import { StudioButton } from "./components/StudioButton"

type HeaderProps = {
  mart: Mart
}

const BreadcrumbsWithPresets = ({ mart }: { mart: Mart }) => {
  const martsPresetsEnabled = useFeatureSwitch("MARTS_PRESETS_ENABLED")

  return (
    <ClientOnlySuspense>
      <Breadcrumbs>
        <Breadcrumb href="/datasets" className="text-xs">
          Datasets
        </Breadcrumb>
        <BreadcrumbSeparator />
        <Breadcrumb className="flex items-center">
          <Suspense fallback={<DatasetSelectorSkeleton mart={mart} />}>
            <DatasetSelector mart={mart} />
          </Suspense>
        </Breadcrumb>
        {martsPresetsEnabled && mart.presets.length > 0 && (
          <Breadcrumb className="has-[button:disabled]:hidden flex items-center">
            <PresetSelector presets={mart.presets} id={mart.mart_id} />
          </Breadcrumb>
        )}
      </Breadcrumbs>
    </ClientOnlySuspense>
  )
}

export const MartDataGridHeader = forwardRef<HTMLDivElement, HeaderProps>(
  function DataGridHeader({ mart }, ref) {
    const exportEnabled = mart.mart_id !== "fundraises"

    return (
      <div
        ref={ref}
        className="flex gap-6 items-center justify-between flex-wrap"
      >
        <BreadcrumbsWithPresets mart={mart} />
        <div className="flex gap-2 items-center justify-between">
          <StudioButton dataset={mart.mart_id} />
          <FeatureSwitch feature="DOWNLOAD_ENABLED">
            {exportEnabled ? <DataGridExportButton /> : null}
          </FeatureSwitch>
        </div>
      </div>
    )
  }
)
